module.exports = [
	{
		"Sl_No": "01",
		"typeOfRoom": "VIP or Deluxe Suite",
		"rentPerDay": "30,000.00"
	},
	{
		"Sl_No": "02",
		"typeOfRoom": "Standard Suite",
		"rentPerDay": "20,000.00"
	},
	{
		"Sl_No": "03",
		"typeOfRoom": "Deluxe Single",
		"rentPerDay": "13,000.00"
	},
	{
		"Sl_No": "04",
		"typeOfRoom": "Luxury Single",
		"rentPerDay": "11,500.00"
	},
	{
		"Sl_No": "05",
		"typeOfRoom": "Standard Single",
		"rentPerDay": "10,000.00"
	},
	{
		"Sl_No": "06",
		"typeOfRoom": "Double Bedded Room (per bed)",
		"rentPerDay": "5,500.00"
	},
	{
		"Sl_No": "07",
		"typeOfRoom": "General Ward (Male/Female)",
		"rentPerDay": "4,200.00"
	},
	{
		"Sl_No": "08",
		"typeOfRoom": "ICU / CCU",
		"rentPerDay": "12,000.00"
	},
	{
		"Sl_No": "09",
		"typeOfRoom": "KT ICU",
		"rentPerDay": "12,000.00"
	},
	{
		"Sl_No": "10",
		"typeOfRoom": "CICU",
		"rentPerDay": "12,000.00"
	},
	{
		"Sl_No": "11",
		"typeOfRoom": "CICU (Step Down)",
		"rentPerDay": "9,000.00"
	},
	{
		"Sl_No": "12",
		"typeOfRoom": "NICU / PICU",
		"rentPerDay": "12,000.00"
	},
	{
		"Sl_No": "13",
		"typeOfRoom": "NICU HDU",
		"rentPerDay": "9,500.00"
	},
	{
		"Sl_No": "14",
		"typeOfRoom": "NICU Isolation HDU",
		"rentPerDay": "9,500.00"
	},
	{
		"Sl_No": "15",
		"typeOfRoom": "NICU Isolation ICU",
		"rentPerDay": "12,000.00"
	},
	{
		"Sl_No": "16",
		"typeOfRoom": "Cardiac HDU",
		"rentPerDay": "7,000.00"
	},
	{
		"Sl_No": "17",
		"typeOfRoom": "General HDU",
		"rentPerDay": "7,000.00"
	},
	{
		"Sl_No": "18",
		"typeOfRoom": "SCU (Special Care Unit)",
		"rentPerDay": "7,000.00"
	},
	{
		"Sl_No": "19",
		"typeOfRoom": "Nursery",
		"rentPerDay": "4,000.00"
	},
	{
		"Sl_No": "20",
		"typeOfRoom": "Oncology Ward (3 Bedded)",
		"rentPerDay": "4,000.00"
	},
	{
		"Sl_No": "21",
		"typeOfRoom": "Oncology – Day Care",
		"rentPerDay": "3,500.00"
	},
	{
		"Sl_No": "22",
		"typeOfRoom": "Ward (4 Bedded)",
		"rentPerDay": "4,000.00"
	},
	{
		"Sl_No": "23",
		"typeOfRoom": "Ward (8 Bedded)",
		"rentPerDay": "4,000.00"
	},
	{
		"Sl_No": "24",
		"typeOfRoom": "Ward (9 Bedded)",
		"rentPerDay": "4,000.00"
	},
	{
		"Sl_No": "25",
		"typeOfRoom": "Ward (Post Cath)",
		"rentPerDay": "4,000.00"
	},
	{
		"Sl_No": "26",
		"typeOfRoom": "Ward (Pre Cath)",
		"rentPerDay": "4,000.00"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/room-service.json
// module id = 864
// module chunks = 0